import type { Match } from '@/types/api';

import { localStorage } from './local-storage';

export const matchData = localStorage<Match | undefined>(
  'match-data',
  undefined,
);
